import React from "react";
import { Routes, Route } from "react-router-dom";
import { routesConfig } from "./routesConfig";

export default function AppRoutes() {
  return (
    <Routes>
      {routesConfig.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
  );
}
